import React from 'react'
import { Link } from 'react-router-dom'
import { ToolkitPageLayout } from '../../../components'

const providerPages = [
  {
    text: 'Training Modules',
    href: '/toolkit/providers/training',
    description: 'Access training materials for managing Sickle Cell Disease.'
  },
  {
    text: 'Extension for Community Health Outcomes (ECHO)',
    href: '/toolkit/providers/echo',
    description:
      'Learn about Project ECHO and how it supports SCD care through telementoring.'
  },
  {
    text: 'Educational Resources',
    href: '/toolkit/providers/educational-resources',
    description:
      'Find presentations, guidelines, and podcasts related to SCD management.'
  },
  {
    text: 'Burnout Solutions',
    href: '/toolkit/providers/burnout-solutions',
    description:
      'Discover strategies to identify, mitigate, and prevent burnout among providers.'
  },
  {
    text: 'Patient Specific Treatment Plans',
    href: '/toolkit/providers/treatment-plans',
    description:
      'Review sample templates for managing SCD in various clinical settings.'
  }
]

export const ProvidersSectionPage: React.FC = () => {
  return (
    <ToolkitPageLayout
      title="Provider Resources"
      breadcrumbs={[
        { label: 'Toolkit', path: '/toolkit' },
        { label: 'Providers', path: '/toolkit/providers' }
      ]}
    >
      <div className="prose max-w-none text-[#3C2416] mb-8">
        <p className="text-xl">
          This section provides a comprehensive suite of tools and resources
          tailored for healthcare providers involved in the care of individuals
          with Sickle Cell Disease (SCD). Explore modules on training,
          educational materials, burnout solutions, and patient-specific
          treatment plans to enhance your practice and improve patient outcomes.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {providerPages.map((page, index) => (
          <Link
            key={index}
            to={page.href}
            className="block p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 transition-colors duration-200 transform hover:scale-105"
          >
            <h5 className="mb-2 text-2xl font-bold tracking-tight text-[#142841]">
              {page.text}
            </h5>
            <p className="font-normal text-[#3C2416]">{page.description}</p>
          </Link>
        ))}
      </div>
    </ToolkitPageLayout>
  )
}
